module.exports = __webpack_public_path__ + "static/media/main_features_lock.3ff6587a.svg";